import envConfig from 'config.env';
import {
  formatContactRequestPayload,
  getTcomConfigParam
} from '../../utils/';

export default class ExpertContactController {
  /* @ngInject */
  constructor($stateParams, $anchorScroll, DataService, ExpertService, $log,
    NetworkService, NavigationService, $window, vcRecaptchaService, ConfigurationService,
    $document, ProductLinkService) {
    const expertId = $stateParams.expertID;

    this.authorable = ConfigurationService.getConfiguration();
    this.$anchorScroll = $anchorScroll;
    this.$log = $log;
    this.testPattern = /^(02|03|04|07|08)[0-9]{8}$/;
    this.form_data = DataService.getData();
    this.NetworkService = NetworkService;
    this.NavigationService = NavigationService;
    this.ProductLinkService = ProductLinkService;
    this.authorable = ConfigurationService.getConfiguration();
    this.$document = $document;
    this.recaptchaKey = getTcomConfigParam($window, 'recaptchaKey') ||
      envConfig.recaptchaKey;
    this.vcRecaptchaService = vcRecaptchaService;
    this.callMeIsActive = false;

    ExpertService
      .getExpert(expertId)
      .then((expert) => {
        this.expert = expert;
      });
  }

  $onInit() {
    this.$anchorScroll();
  }

  submitForm() {
    const element = this.$document[0].querySelector('input.ng-invalid');
    if (element) {
      const duration = 500;
      // this number is approximately the space between
      // an invalid element and the top of the viewport
      const offset = 100;
      this.$document.scrollToElement(element, offset, duration);
    }
    if (
      !this.expertFinderContactExpert.$error.required &&
      !this.expertFinderContactExpert.$error.pattern &&
      !this.expertFinderContactExpert.$error.email
    ) {
      this.vcRecaptchaService.reload(this.widgetId);
      this.vcRecaptchaService.execute(this.widgetId);
    }
  }

  setResponse(response) {
    this.form_data.captchaResponse = response;
    this.notifyExpert();
  }

  setWidgetId(widgetId) {
    this.widgetId = widgetId;
  }

  cbExpiration() {
    this.vcRecaptchaService.reload(this.widgetId);
    this.form_data.captchaResponse = null;
  }

  returnToResultsPage() {
    if (this.ProductLinkService.linkIsFromProductPage) {
      this.NavigationService
        .navigateToDirectLinkageSearchResults(this.ProductLinkService.getSearchParams());
    } else {
      this.NavigationService.navigateToSearchResults();
    }
  }

  resetFormProperty(...args) {
    args.forEach((arg) => {
      if (this.form_data[arg]) {
        this.form_data[arg] = '';
        delete this.form_data[arg];
      }
    });
  }

  notifyExpert() {
    const processedPayloadData = formatContactRequestPayload(this.form_data);
    const isProductLink = this.ProductLinkService.getProductLinkVerification();
    const payload = {
      data: {
        gCaptchaToken: this.form_data.captchaResponse,
        firstName: this.form_data.first_name,
        lastName: this.form_data.surname,
        companyName: this.form_data.company,
        email: this.form_data.email,
        callBackDate: this.form_data.contactMethod === 'PHONE' && this.form_data.callbackDate ? this.form_data.callbackDate : '',
        contactNumber: this.form_data.phoneNumber,
        contactTime: processedPayloadData.contactTime || [],
        contactMethod: this.form_data.contactMethod,
        comments: this.form_data.moreInfo,
        solutions: processedPayloadData.solutions,
        isProductLink
      }
    };
    if (!isProductLink) {
      const noneProductLinkPayload = {
        role: this.form_data.myRoleOther ? this.form_data.myRoleOther : this.form_data.myRole,
        department: this.form_data.myDepartment,
        fteFrom: processedPayloadData.fteFrom,
        fteTo: processedPayloadData.fteTo,
        postcode: processedPayloadData.postcode,
        industry: this.form_data.myIndustry,
        coverage: processedPayloadData.coverage,
      };
      payload.data = { ...payload.data, ...noneProductLinkPayload };
    }
    this.$anchorScroll();
    this.NetworkService.notifyExpert(this.expert.id, payload)
      .then((result) => {
        if (result) {
          this.NavigationService.navigateToContactSuccess(this.expert.id);
        }
      });
  }

  addCallTimeToFormPayload() {
    this.callMeIsActive = !this.callMeIsActive;
  }
}



// WEBPACK FOOTER //
// ./src/containers/expert-contact/expert-contact.controller.js